
import { Component } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import SubModule from '@/components/SubModule.vue';
import { IMenuItem } from '@/components/Menu.vue';
import routes from './routes';
import store from './store';
import { EntityStoreGetters } from '@/base';

@Component
export default class BusinessUnit extends SubModule
{
  private get activeItem(): typeof store[EntityStoreGetters.ACTIVE_ITEM]
  {
    return store[EntityStoreGetters.ACTIVE_ITEM];
  }

  protected _getRoutes(): RouteConfig[]
  {
    return routes;
  }

  protected _getDynamicMenuItems(): IMenuItem[]
  {
    const activeItem = this.activeItem;
    if (activeItem)
    {
      if (activeItem.$isCreated())
      {
        return [
          {
            title: activeItem.$original.name,
            icon: `$vuetify.icons.edit`,
            route: `/businessunit/${activeItem.id}`,
          },
          {
            title: this.$t('invoiceContact.title').toString(),
            icon: '$vuetify.icons.contact',
            route: `/businessunit/${activeItem.id}/invoicecontact`,
          },
          {
            title: this.$t('bankAccountCollection.title').toString(),
            icon: '$vuetify.icons.bankaccountcollection',
            route: `/businessunit/${activeItem.id}/bankaccountcollection`,
          },
        ];
      }
      else
      {
        return [
          {
            title: this.$t('form.titleNew').toString(),
            icon: `$vuetify.icons.add`,
            route: `/businessunit/new`,
          },
        ];
      }
    }
    return [];
  }
}
